import React from 'react';
import queryString from 'query-string';
import PropTypes from 'prop-types';

import { Pinterest } from 'components/icons';

const PinterestShare = ({ product, className }, { testId }) => {
  const pinterestLink = 'https://pinterest.com/pin/create/button/?' + queryString.stringify({
    url: product.link,
    media: product.image,
    description: product.name
  });

  return (
    <a
      href={pinterestLink}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label="Share on Pinterest"
      data-te="TE_PDP_SHAREPINTEREST"
      data-test-id={testId('pinterestShareIcon')}>
      <Pinterest size={22}/>
    </a>
  );
};

PinterestShare.contextTypes = {
  testId: PropTypes.func.isRequired
};

export default PinterestShare;
